"use strict";

exports.__esModule = true;
var _LandingScreen = require("./LandingScreen");
Object.keys(_LandingScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LandingScreen[key]) return;
  exports[key] = _LandingScreen[key];
});
var _DomainName = require("./DomainName");
Object.keys(_DomainName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DomainName[key]) return;
  exports[key] = _DomainName[key];
});
var _NotificationsIcon = require("./NotificationsIcon");
Object.keys(_NotificationsIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NotificationsIcon[key]) return;
  exports[key] = _NotificationsIcon[key];
});